import React from "react";
import styles from "./process.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faArrowTrendUp,
    faBolt, faChartLine,
    faGrimace,
    faGrin,
    faGrinHearts,
    faGrinTears,
    faGrinWink,
    faMobileAlt, faPalette, faSearch
} from "@fortawesome/free-solid-svg-icons";
import LazyText from "../../../common/imagescroll/LazyText";


const Process: React.FC = () => {

    const processSteps = [
        {
            title: "Requirements",
            num: "01",
            description: "We define your business needs, workflows, and technical goals to ensure clarity from day one."
        },
        {
            title: "Architecture",
            num: "02",
            description: "We design a scalable, secure system architecture built for performance and future growth."
        },
        {
            title: "Development",
            num: "03",
            description: "Your application is built using modern technologies with clean, maintainable code."
        },
        {
            title: "Testing",
            num: "04",
            description: "We rigorously test functionality, performance, and security before launch."
        },
        {
            title: "Deployment",
            num: "05",
            description: "Your application is deployed smoothly with optimized configuration and monitoring."
        },
        {
            title: "Support",
            num: "06",
            description: "Ongoing support and improvements to keep your system reliable and evolving."
        }
    ];


    return (

        <section className={styles.sectionContainer}>
            <LazyText>
                <h2 className="sectionTitle" style={{marginTop:"60px"}}>
                    Our Simple, Streamlined Process
                </h2>
            </LazyText>
            <div className={styles.timelineContainer}>
                <div className={styles.timeline}>
                    {processSteps.map((step, index) => (
                        <div key={index} className={`${styles.stepContainer} ${styles.primary}`}>
                            <div className={styles.timelineNumber}>
                                {step.num}
                            </div>
                            <div className={styles.timelineBody}>
                                <h4 className={styles.timelineTitle}>
                                    {step.title}
                                </h4>
                                <p>
                                    {step.description}
                                </p>
                            </div>
                        </div>

                    ))}
                </div>
            </div>
        </section>
    );
};

export default Process;
